var _rect, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCalender = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4.5,
    width: 12,
    height: 10,
    rx: 2,
    stroke: "#3D3D3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.16667C2 6.54669 2 6.2367 2.06815 5.98236C2.25308 5.29218 2.79218 4.75308 3.48236 4.56815C3.7367 4.5 4.04669 4.5 4.66667 4.5H11.3333C11.9533 4.5 12.2633 4.5 12.5176 4.56815C13.2078 4.75308 13.7469 5.29218 13.9319 5.98236C14 6.2367 14 6.54669 14 7.16667H2Z",
    fill: "#3D3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 2.5L4.66675 4.5",
    stroke: "#3D3D3D",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 2.5L11.3333 4.5",
    stroke: "#3D3D3D",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.66675,
    y: 8.5,
    width: 2.66667,
    height: 1.33333,
    rx: 0.5,
    fill: "#3D3D3D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.66675,
    y: 11.1666,
    width: 2.66667,
    height: 1.33333,
    rx: 0.5,
    fill: "#3D3D3D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.66675,
    y: 8.5,
    width: 2.66667,
    height: 1.33333,
    rx: 0.5,
    fill: "#3D3D3D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.66675,
    y: 11.1666,
    width: 2.66667,
    height: 1.33333,
    rx: 0.5,
    fill: "#3D3D3D"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalender, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calender.5ebaca67.svg";
export { ForwardRef as ReactComponent };